import {formatDateDTO} from "../../utils/FormatUtils";
import {COLUMN_KEY} from "../const/constant";

export const convertSubmitData = (values: any, item: any) => {
  const convertFunc = {
    [COLUMN_KEY.TOPIC]: convertDocumentTopicData,
    [COLUMN_KEY.CRITERIA]: convertCriteriaData,
  }
  const rawData = values[item?.code];
  const data = Object.keys(convertFunc).includes(item?.code) ? convertFunc[item?.code](rawData) : rawData;
  return {
    ...data,
    doCreation: data?.id ? formatDateDTO(data?.doCreation) : formatDateDTO(new Date()),
  }
}

export const convertCriteriaData = (values: any) => {

  return values;
}

export const convertDocumentTopicData = (values: any) => {
  delete values.listCriteriaCode;
  delete values.listCriteriaName;
  delete values.listCriteria;

  return values;
}